import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import { MovileService } from "../../../services/movile.service";
import NumberFormatCustom from "../../stateless/NumberFormatCustom";
import Transition from "../../stateless/Transition";
import styles from "../../../styles/global-styles";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";
import { validateEmptyValuesInForm } from "../../../_utils/utils";
import { AccesoryService } from "../../../services/accesory.service";
import { ChipService } from "../../../services/chip.service";
import SubcategorySelect from "../../shared/selects/SubcategorySelect";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  formControl: styles.globalFormControl,
}));

const GlobalEdition = ({
  onClose,
  open,
  productsSelected,
  productsUpdated,
  productType,
  sizeProducts,
}) => {
  const classes = useStyles();
  const [editionParams, setEditionParams] = useState({});
  const [errorSubcategory, setErrorSubcategory] = useState(false);

  const handleSubmitForm = async () => {
    const validateParams = validateEmptyValuesInForm(editionParams);
    let statusResponse = null;
    console.log("validateParams", validateParams);
    try {
      if (productType === 1) {
        const { status } = await MovileService.updateMovilePrices(
          productsSelected,
          validateParams
        );
        console.log("result update MOVILE", status);
        statusResponse = status;
      } else if (productType === 2) {
        console.log("productsSelected", productsSelected);
        const { status } = await AccesoryService.bulkUpdateAccesoryPrices(
          productsSelected,
          validateParams
        );
        console.log("result update ACCESORY", status);
        statusResponse = status;
      } else if (productType === 3) {
        const { status } = await ChipService.updatePricesByBulk(
          productsSelected,
          validateParams
        );
        console.log("status update CHIP", status);
        statusResponse = status;
      }

      if (statusResponse === 201) {
        productsUpdated(true, "Productos actualizados exitosamente", "update");
        setEditionParams({});
      }
    } catch (error) {
      console.log("error UPDATE global edition", error);
      productsUpdated(false, "Error al actualizar los productos", "update");
    }
    onClose();
  };

  const handleInputText = ({ target: { name, value } }) => {
    setEditionParams({ ...editionParams, [name]: value });
  };

  const handleSubcategorySelected = (key, value) => {
    setEditionParams({ ...editionParams, [key]: value });
    setErrorSubcategory(false);
  };

  const handleClose = () => onClose();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Editar productos seleccionados
      </DialogTitle>
      <DialogContent>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Costo
              </Typography>
              <TextField
                name="cost"
                value={editionParams.cost}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              />
            </Box>
          </Grid>
          <Grid item>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Precio
              </Typography>
              <TextField
                name="price"
                value={editionParams.price}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              />
            </Box>
          </Grid>

          {productType !== 3 && (
            <Grid item>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Descuento
                </Typography>
                <TextField
                  name="discount"
                  value={editionParams.discount}
                  onChange={(e) => handleInputText(e)}
                  variant="outlined"
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                  }}
                />
              </Box>
            </Grid>
          )}

          {productType === 2 && sizeProducts === productsSelected.length && (
            <Grid item xs={7}>
              <Box className={classes.box}>
                <SubcategorySelect
                  errorSubcategory={errorSubcategory}
                  formOption
                  subcategory={handleSubcategorySelected}
                />
              </Box>
            </Grid>
          )}

          <ConfirmButtons
            handleSubmitForm
            cancel={() => onClose()}
            accept={handleSubmitForm}
          />
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(GlobalEdition);
